import * as React from 'react';
import Seo from '../components/seo';
import Layout from '../components/layout';

function NotFoundPage() {
  return (
    <Layout>
      <Seo title="Thank You" />
      <div className="text-center">
        <h1 className="mt-2 text-4xl font-bold tracking-tight text-primary sm:text-5xl">
          Page Not Found
        </h1>
        <p className="mt-2 text-base text-background">
          This page is still in the greenhouse.
        </p>
        <div className="mt-6">
          <a
            href="/"
            className="text-base font-medium text-primary hover:text-secondary"
          >
            Go back home
            <span aria-hidden="true"> &rarr;</span>
          </a>
        </div>
      </div>
    </Layout>
  );
}

export default NotFoundPage;
